/* ==================================================================
 * PLACEHOLDER FRAMES
 *
 * Draws a rough perspective "street" that recedes as you scroll, so
 * you can test the scroll feel, the beat timings and the portal
 * handoff before the client has shot anything in Porto-Vecchio.
 *
 * The moment real frames land in public/frames/modern/, this file
 * stops being used. You can delete it before launch.
 * ================================================================== */

export function drawPlaceholder(ctx, w, h, t, frameNo, frameTotal) {
  ctx.save();

  // sky / far light
  const sky = ctx.createLinearGradient(0, 0, 0, h);
  sky.addColorStop(0, "#1b1710");
  sky.addColorStop(0.55, "#2a2318");
  sky.addColorStop(1, "#0f0d09");
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, w, h);

  const vpX = w * 0.5;
  const vpY = h * 0.46;

  // glow at the vanishing point, grows as you walk toward it
  const glowR = Math.max(w, h) * (0.06 + t * 0.34);
  const glow = ctx.createRadialGradient(vpX, vpY, 0, vpX, vpY, glowR);
  glow.addColorStop(0, `rgba(192, 139, 62, ${0.22 + t * 0.5})`);
  glow.addColorStop(1, "rgba(192, 139, 62, 0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, w, h);

  // ground
  ctx.fillStyle = "rgba(10, 9, 6, 0.85)";
  ctx.beginPath();
  ctx.moveTo(0, h);
  ctx.lineTo(vpX, vpY);
  ctx.lineTo(w, h);
  ctx.closePath();
  ctx.fill();

  // buildings marching toward the camera
  const COUNT = 12;
  const SPACING = 1 / COUNT;

  for (let i = COUNT; i >= 0; i--) {
    // depth: 0 at the camera, 1 at the vanishing point
    let d = (i * SPACING - t * 0.9) % 1;
    if (d < 0) d += 1;

    const persp = 1 / (0.12 + d * 3.4);
    const halfW = w * 0.5 * persp * 0.9;
    const topY = vpY - h * 0.42 * persp;
    const botY = vpY + h * 0.5 * persp;

    if (halfW < 2 || halfW > w * 4) continue;

    const shade = Math.max(0, Math.min(1, 1 - d));
    const alpha = 0.1 + shade * 0.55;

    // left facade
    ctx.fillStyle = `rgba(58, 48, 34, ${alpha})`;
    ctx.fillRect(vpX - halfW - w * 0.5, topY, w * 0.5, botY - topY);
    ctx.strokeStyle = `rgba(232, 220, 196, ${alpha * 0.16})`;
    ctx.lineWidth = 1;
    ctx.strokeRect(vpX - halfW - w * 0.5, topY, w * 0.5, botY - topY);

    // right facade
    ctx.fillStyle = `rgba(44, 37, 26, ${alpha})`;
    ctx.fillRect(vpX + halfW, topY, w * 0.5, botY - topY);
    ctx.strokeStyle = `rgba(232, 220, 196, ${alpha * 0.16})`;
    ctx.strokeRect(vpX + halfW, topY, w * 0.5, botY - topY);

    // a lit window on each side
    const winH = (botY - topY) * 0.13;
    ctx.fillStyle = `rgba(192, 139, 62, ${alpha * 0.5})`;
    ctx.fillRect(vpX - halfW - w * 0.16, topY + winH * 1.4, w * 0.07, winH);
    ctx.fillRect(vpX + halfW + w * 0.09, topY + winH * 2.2, w * 0.07, winH);
  }

  // dust
  for (let i = 0; i < 40; i++) {
    const seed = (i * 97.13 + t * 140) % 100;
    const x = ((i * 61.7) % 100) / 100 * w;
    const y = ((seed * 7.3) % 100) / 100 * h;
    ctx.fillStyle = `rgba(232, 220, 196, ${0.02 + (i % 4) * 0.012})`;
    ctx.fillRect(x, y, 2, 2);
  }

  // dev label
  ctx.font = `${Math.round(h * 0.016)}px ui-monospace, Menlo, monospace`;
  ctx.fillStyle = "rgba(232, 220, 196, 0.34)";
  ctx.textAlign = "center";
  ctx.fillText(
    `PLACEHOLDER  ·  frame ${frameNo} / ${frameTotal}`,
    w / 2,
    h * 0.055
  );
  ctx.fillText(
    "drop your frames in public/frames/modern/",
    w / 2,
    h * 0.055 + h * 0.024
  );

  ctx.restore();
}
